import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { UserInfo } from 'services/types';
import DialogConfirmation from 'components/DialogConfirmation';

interface IModalDeleteUserProps {
  open: boolean;
  selectedUserInfoList: UserInfo[];
  disabled: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UserList = ({ selectedUserInfoList }: { selectedUserInfoList: UserInfo[] }) => (
  <ul style={{ margin: '0.8rem 0 1.6rem' }}>
    {selectedUserInfoList.map((user) => (
      <li key={user._id}>
        <Typography variant="body1" color="text.secondary">
          - {user.name}
        </Typography>
      </li>
    ))}
  </ul>
);

const ModalDeleteUser: React.FC<IModalDeleteUserProps> = (props: IModalDeleteUserProps) => {
  const { open, selectedUserInfoList, disabled, onCancel, onConfirm } = props;
  const { t } = useTranslation();
  const keyword = t('deleteUsersConfirmationKeyword');

  const description = (
    <>
      <Typography variant="body1" color="text.primary">
        {t('deleteUsersModalMessage')}
      </Typography>
      <UserList selectedUserInfoList={selectedUserInfoList} />
    </>
  );

  return (
    <DialogConfirmation
      variant="warning"
      open={open}
      title={t('deleteUsers')}
      description={description}
      confirmationKeyword={keyword}
      disabled={disabled}
      confirmLabel={t('deleteUsers')}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default ModalDeleteUser;
